import { tenantAdminRoutes } from 'src/router/tenant-admin-routes'
import { useRouter } from 'vue-router'
import { useContext } from 'src/modules/core/composables/useContext'

export function useTenantAdminSessionFactory() {
  const router = useRouter()
  const { onLoadStructures } = useContext()

  async function onCreateTenantAdminSession() {
    tenantAdminRoutes.forEach(router.addRoute)

    await onLoadStructures()
  }

  return { onCreateTenantAdminSession }
}
